<template>
  <div class="box" style="overflow: auto">
    <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="skeleton" />
    <Nodata v-if="noData" />
    <div class="card" v-if="show == 'not_set' ? !noData : show">
      <div class="table-responsive">
        <table :class="defaultFormat + format">
          <slot></slot>
        </table>
      </div>
    </div>
    <b-pagination
      align="center"
      class="mt-2"
      :total-rows="meta.total"
      :per-page="filter.per_page"
      @input="action"
      v-model="filter.page"
      v-if="!noData && pagination && !skeleton"
    />
  </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
export default {
  mixins: [helper],
  props: {
    meta: {
      // type: Object,
      default() {
        return { total: 5 };
      },
    },
    filter: {
      type: Object,
      default() {
        return { per_page: 10, page: 1 };
      },
    },
    defaultFormat: {
      default:
        "table table-vcenter table-hover table-control table-striped card-table",
    },
    format: { default: "" },
    pagination: { default: false },
    skeleton: { default: false },
    noData: { default: false },
    show: { default: "not_set" },
    action: {
      type: Function,
    },
  },
};
</script>
